<template>
  <div>
    <v-data-table
      id="table-orders"
      :headers="headers"
      :items="items"
      class="elevation-0"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      disable-sort
      item-class="properties"
      :dense="false"
      :footer-props="footerProps"
    >
      <template v-slot:item.patent="{ item }">
        <router-link
          :to="{
            name: 'OverviewPatent',
            params: { id: item.patent.id },
            query: { ordersQuery: true },
          }"
          style="text-decoration: underline; color: inherit;"
        >
          {{ item.patent.name }}
        </router-link>
      </template>
      <template v-slot:item.organisation="{ item }">
        <router-link
          :to="{
            name: 'OverviewProvider',
            params: { id: item.patent.organisation.id },
            query: { patentOrdersadminQuery: true },
          }"
          style="text-decoration: underline; color: inherit;"
        >
          {{ item.patent.organisation.name }}
        </router-link>
      </template>
      <template v-slot:item.orderBy="{ item }">
        <router-link
          :to="{
            name: 'UserOverview',
            params: { id: item.user.id },
            query: { patentOrders: true },
          }"
          style="text-decoration: underline; color: inherit;"
        >
          {{ item.user.fullName }}
        </router-link>
      </template>
      <template v-slot:item.orderDate="{ item }">
        <span>
          {{ formatDateLocaleAE(item.createdTimestamp) }}
        </span>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip :color="getOrderColor(item.status.id)">
          {{ item.status.description + (item.statusExplicit ? ' - ' + item.statusExplicit : '') }}
        </v-chip>
      </template>
      <template v-slot:item.rating="{ item }">
        <v-rating
          :value="item.orderPatentEvaluation != null ? item.orderPatentEvaluation.stars : 0"
          readonly
          dense
          hover
          class="custom-rating"
        ></v-rating>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn color="primary" text @click="onViewItem(item)">
          View
        </v-btn>
        <v-btn
          color="primary"
          text
          v-if="item.uuidProvider && item.status.id == 'REQUESTED'"
          @click="acceptOrder(item)"
        >
          Accept
        </v-btn>
        <v-btn
          color="primary"
          text
          v-if="item.uuidProvider && item.status.id == 'REQUESTED'"
          @click="rejectOrder(item)"
        >
          Reject
        </v-btn>
        <v-btn
          color="primary"
          text
          v-if="item.uuidProvider && item.status.id == 'ACCEPTED_BY_RESEARCHER'"
          :to="{
            name: 'OrderCompletedByProvider',
            query: {
              uuid: item.uuidProvider,
              publicContactEmail: $store.getters.email,
              type: 'patent',
            },
          }"
        >
          Complete
        </v-btn>
        <v-btn
          color="primary"
          text
          v-if="
            item.uuidProvider &&
              role === 'super-admin' &&
              item.status.id !== 'COMPLETED_BY_PROVIDER'
          "
          @click="forceCompleteOffer(item)"
        >
          Force Complete
        </v-btn>
        <v-btn
          color="primary"
          text
          v-if="item.uuidProvider && item.status.id == 'ACCEPTED_BY_RESEARCHER'"
          :to="{
            name: 'OrderInvalidatedByProvider',
            query: {
              uuid: item.uuidProvider,
              publicContactEmail: $store.getters.email,
              type: 'patent',
            },
          }"
        >
          Invalidate
        </v-btn>
        <v-btn
          v-if="role === 'super-admin'"
          color="primary"
          text
          @click="(itemToBeDeleted = item), (deleteDialog = true)"
        >
          Delete
        </v-btn>
      </template>
    </v-data-table>

    <!-- OverView Dialog -->
    <v-dialog v-model="dialogView" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Order
          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click="timestampDialog(viewItem)">
            <v-icon>mdi-clock-time-eight</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-4">
          <h3>Patent:</h3>
          <div>
            {{ viewItem.patent.name }}
          </div>
          <h3 class="mt-2">Organisation:</h3>
          <div>
            {{ viewItem.patent.organisation.name }}
          </div>
          <h3 class="mt-2">Order By:</h3>
          <div>
            {{ viewItem.user.fullName }}
          </div>
          <h3 class="mt-2">Order Date:</h3>
          <div>
            {{ formatDateLocaleAE(viewItem.createdTimestamp) }}
          </div>
          <h3 class="mt-2">Status:</h3>
          <div>
            {{ viewItem.status.description }}
          </div>
          <h3 v-if="viewItem.fromDate" class="mt-2">From:</h3>
          <div>
            {{ formatDate(viewItem.fromDate) }}
          </div>
          <h3 v-if="viewItem.toDate" class="mt-2">To:</h3>
          <div>
            {{ formatDate(viewItem.toDate) }}
          </div>
          <h3 v-if="viewItem.useCase" class="mt-2">Use Case:</h3>
          <div>
            {{ viewItem.useCase }}
          </div>
          <h3 v-if="viewItem.additionalInformation" class="mt-2">Additional Prerequisites:</h3>
          <div>
            {{ viewItem.additionalInformation }}
          </div>
          <h3 v-if="viewItem.publicContactEmail" class="mt-2">Public Contact Email:</h3>
          <div>
            {{ viewItem.publicContactEmail }}
          </div>
          <h3 v-if="viewItem.cost" class="mt-2">Cost:</h3>
          <div>
            {{ viewItem.cost }}
          </div>
          <h3 v-if="viewItem.instructions" class="mt-2">Instructions:</h3>
          <div>
            {{ viewItem.instructions }}
          </div>
          <h3 v-if="viewItem.phone" class="mt-2">Phone:</h3>
          <div>
            {{ viewItem.phone }}
          </div>
          <h3 v-if="viewItem.email" class="mt-2">Email:</h3>
          <div>
            {{ viewItem.email }}
          </div>
          <div v-if="viewItem && viewItem.orderPatentEvaluation != null">
            <h3 class="mt-2">Feedback:</h3>
            <div>
              {{ viewItem.orderPatentEvaluation.feedback }}
            </div>
          </div>
          <div>
            <div v-if="viewItem && viewItem.rejectionProviderReason != null">
              <h3 class="mt-2">Rejection Provider Reason:</h3>
              <div>
                {{ viewItem?.rejectionProviderReason?.description }}
              </div>
            </div>
            <div v-if="viewItem && viewItem.comments != null">
              <h3 class="mt-2">
                Accepted by Provider Comments:
              </h3>
              <div>
                {{ viewItem?.comments || '-' }}
              </div>
            </div>
            <div v-if="viewItem && viewItem.acceptResearcherCommends != null">
              <h3 class="mt-2">
                Accepted by Researcher Comments:
              </h3>
              <div>
                {{ viewItem?.acceptResearcherCommends || '-' }}
              </div>
            </div>
            <div v-if="viewItem && viewItem.rejectComments != null">
              <h3 class="mt-2">
                Rejected by Provider Comments:
              </h3>
              <div>
                {{ viewItem?.rejectComments || '-' }}
              </div>
            </div>
            <div v-if="viewItem && viewItem.rejectionResearcherReason != null">
              <h3 class="mt-2">Rejection Researcher Reason:</h3>
              <div>
                {{ viewItem?.rejectionResearcherReason?.description }}
              </div>
            </div>
            <div v-if="viewItem && viewItem.rejectResearcherCommends != null">
              <h3 class="mt-2">
                Rejected by Researcher Comments:
              </h3>
              <div>
                {{ viewItem?.rejectResearcherCommends || '-' }}
              </div>
            </div>
            <div v-if="viewItem && viewItem.completeCommends != null">
              <h3 class="mt-2">
                Completed by Provider Comments:
              </h3>
              <div style="color: green; font-weight: bold">
                {{ viewItem?.completeCommends || '-' }}
              </div>
            </div>
            <div v-if="viewItem && viewItem.invalidateCommends != null">
              <h3 class="mt-2">
                Invalidated by Provider Comments:
              </h3>
              <div style="color: red; font-weight: bold">
                {{ viewItem?.invalidateCommends || '-' }}
              </div>
            </div>
            <div v-if="viewItem && viewItem.forceCompleteCommends != null">
              <h3 class="mt-2">
                Completed by Admin Comments:
              </h3>
              <div style="color: green; font-weight: bold">
                {{ viewItem?.forceCompleteCommends || '-' }}
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogView = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Timestamp Dialog -->
    <v-dialog v-model="timestampView" width="400">
      <v-card>
        <v-card-text>
          <v-row class="mt-2 justify-space-between">
            <v-col cols="auto">
              <div class="font-weight-bold">Requested Order:</div>
            </v-col>
            <v-col cols="auto">
              {{ formatDateTime(viewItem.createdTimestamp) }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-if="viewItem.comments">
          <v-row class="justify-space-between">
            <v-col cols="auto">
              <div class="font-weight-bold">Accepted by Provider:</div>
            </v-col>
            <v-col cols="auto">
              {{ formatDateTime(viewItem.updatedByProvider) }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-if="viewItem.rejectComments">
          <v-row class="justify-space-between">
            <v-col cols="auto">
              <div class="font-weight-bold">Rejected by Provider:</div>
            </v-col>
            <v-col cols="auto">
              {{ formatDateTime(viewItem.updatedByProvider) }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-if="viewItem.acceptResearcherCommends">
          <v-row class="justify-space-between">
            <v-col cols="auto">
              <div class="font-weight-bold">Accepted by Researcher:</div>
            </v-col>
            <v-col cols="auto">
              {{ formatDateTime(viewItem.updatedByResearcher) }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-if="viewItem.rejectResearcherCommends">
          <v-row class="justify-space-between">
            <v-col cols="auto">
              <div class="font-weight-bold">Rejected by Researcher:</div>
            </v-col>
            <v-col cols="auto">
              {{ formatDateTime(viewItem.updatedByResearcher) }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row class="justify-space-between">
            <v-col cols="auto">
              <div class="font-weight-bold" v-if="viewItem.status.id === 'INVALIDATED_BY_PROVIDER'">
                Invalidated:
              </div>
              <div v-else class="font-weight-bold">
                Completed:
              </div>
            </v-col>
            <v-col cols="auto">
              {{ formatDateTime(viewItem.completedTimestamp) || 'Not Yet' }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Delete Dialog -->
    <v-dialog v-if="itemToBeDeleted !== null" v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Remove</v-card-title>
        <v-card-text>
          {{ $t('delete.confirm') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="deleteDialog = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="red darken-1" text @click="onDeleteItem" :disabled="disableDelete">
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Accept Order Dialog -->
    <v-dialog v-model="acceptOrderDialog" max-width="1000px" persistent>
      <v-card class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="pb-5">
          <v-row>
            <v-col cols="12" class="d-flex pa-0 text-center justify-center">
              <p class="font-weight-bold neutral--text pb-4 pt-6">{{ 'Accept Order' }}</p>
            </v-col>
          </v-row>
          <v-btn icon @click="acceptOrderDialog = false" left>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="acceptOrderForm" v-model="valid" :lazy-validation="false">
            <v-row>
              <v-col cols="12" class="py-0">
                <label>Cost</label>
                <v-text-field
                  v-model="item.cost"
                  :placeholder="'Cost'"
                  outlined
                  clearable
                  :rules="requiredRule()"
                  class="required"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <label>Instructions</label>
                <v-textarea
                  v-model="item.instructions"
                  :placeholder="'instructions'"
                  outlined
                  clearable
                  :rules="requiredRule()"
                  class="required"
                ></v-textarea>
              </v-col>
              <v-col cols="12" class="py-0">
                <label>Phone</label>
                <v-text-field
                  v-model="item.phone"
                  :placeholder="'Phone'"
                  outlined
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <label>Email</label>
                <v-text-field
                  v-model="item.email"
                  :placeholder="'Email'"
                  :rules="emailRules()"
                  outlined
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <label>Comments</label>
                <v-textarea
                  v-model="item.comments"
                  :placeholder="'Comments'"
                  outlined
                  clearable
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row style="width: 100%">
            <v-col cols="12">
              <v-btn
                @click="acceptOrderByProvider"
                :disabled="!valid"
                block
                depressed
                rounded
                large
                class="white--text font-weight-bold"
                color="black"
                >{{ $t('submit') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Reject Order Dialog -->
    <v-dialog v-model="rejectOrderDialog" max-width="1000px" persistent>
      <v-card class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="pb-5">
          <v-row>
            <v-col cols="12" class="d-flex pa-0 text-center justify-center">
              <p class="font-weight-bold neutral--text pb-4 pt-6">{{ 'Reject Order' }}</p>
            </v-col>
          </v-row>
          <v-btn icon @click="rejectOrderDialog = false" left>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="rejectOrderForm" v-model="valid" :lazy-validation="false">
            <v-row>
              <v-col cols="12" class="py-0">
                <label>Rejection Reason</label>
                <v-select
                  v-model="item.rejectionReason"
                  :items="rejectionReasons"
                  item-text="text"
                  item-value="value"
                  :placeholder="'Select a reason'"
                  outlined
                  clearable
                  :rules="requiredRule()"
                  class="required"
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-col>
              <v-col v-if="item.rejectionReason == 'OTHER'" cols="12" class="py-0">
                <label>Comment</label>
                <v-textarea
                  v-model="item.rejectComments"
                  :placeholder="'Comments'"
                  outlined
                  clearable
                  :rules="requiredRule()"
                  class="required"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row style="width: 100%">
            <v-col cols="12">
              <v-btn
                @click="rejectOrderByProvider"
                :disabled="!valid"
                block
                depressed
                rounded
                large
                class="white--text font-weight-bold"
                color="black"
                >{{ $t('submit') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Force Complete Order Dialog -->
    <v-dialog v-model="forceCompleteDialog" max-width="1000px" persistent>
      <v-card class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="pb-5">
          <v-row>
            <v-col cols="12" class="d-flex pa-0 text-center justify-center">
              <p class="font-weight-bold neutral--text pb-4 pt-6">{{ 'Complete Order' }}</p>
            </v-col>
          </v-row>
          <v-btn icon @click="forceCompleteDialog = false" left>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="forceCompleteOrderForm" v-model="valid" :lazy-validation="false">
            <v-row>
              <v-col cols="12" class="py-0">
                <label>Comment</label>
                <v-textarea
                  v-model="item.forceCompleteComments"
                  :placeholder="'Comments'"
                  outlined
                  clearable
                  :rules="requiredRule()"
                  class="required"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row style="width: 100%">
            <v-col cols="12">
              <v-btn
                @click="forceCompleteOfferByAdmin(selectedOrder)"
                :disabled="!valid"
                block
                depressed
                rounded
                large
                class="white--text font-weight-bold"
                color="black"
                >{{ $t('submit') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'TablePatentsOrderAdmin',
  mixins: [util],
  props: {
    urlApi: String,
    urlApiDelete: String,
    search: Object,
    searchAttributes: Array,
    viewRouter: String,
    headers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    firstLoad: true,
    totalItems: 0,
    items: [],
    loading: true,
    options: {},
    itemToBeDeleted: null,
    deleteDialog: false,
    disableDelete: false,
    footerProps: { 'items-per-page-options': [10, 15, 25, 50, 100] },
    dialogView: false,
    viewItem: {
      patent: {
        organisation: {
          name: null,
        },
      },
      user: {
        fullName: null,
      },
      createdTimestamp: null,
      updatedByProvider: null,
      updatedByResearcher: null,
      completedTimestamp: null,
      status: {
        description: null,
      },
      useCase: null,
      additionalInformation: null,
      fromDate: null,
      toDate: null,
      publicContactEmail: null,
      cost: null,
      instructions: null,
      phone: null,
      email: null,
      comments: null,
      rejectComments: null,
      orderEvaluation: null,
      rejectionReason: null,
    },
    item: {
      cost: '',
      instructions: '',
      phone: '',
      email: '',
      comments: '',
      rejectComments: '',
      forceCompleteComments: '',
      rejectionReason: null,
    },
    rejectionReasons: [
      { text: 'Incomplete Request Information', value: 'INCOMPLETE_REQUEST_INFORMATION' },
      { text: 'Invalid Or Incorrect Details', value: 'INVALID_OR_INCCORECT_DETAILS' },
      { text: 'Requested Service Not Available', value: 'REQUESTED_SERVICE_NOT_AVAILABLE' },
      { text: 'Request Outside Lab Scope', value: 'REQUEST_OUTSIDE_LAB_SCOPE' },
      { text: 'Insufficient Resources/Staff', value: 'INSUFFICIENT_RESOURCES_STAFF' },
      { text: 'Duplicate Request', value: 'DUPLICATE_REQUEST' },
      {
        text: 'Request Expired / No Response From User',
        value: 'REQUEST_EXPIRED_NO_RESPONSE_FROM_USER',
      },
      { text: 'Other', value: 'OTHER' },
    ],
    acceptOrderDialog: false,
    rejectOrderDialog: false,
    forceCompleteDialog: false,
    selectedOrder: null,
    valid: false,
    timestampView: false,
  }),
  watch: {
    options: {
      handler() {
        console.log('[Table] Options watch');
        if (!this.firstLoad) {
          this.getDataFromApi().then(data => {
            this.items = data.items;
            this.totalItems = data.total;
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    console.log('[Table] Mounted');
    if (this.firstLoad) {
      /* Populate table from route */
      this.options.page = this.$route.query.index ? Number(this.$route.query.index) + 1 : 1;
      this.options.itemsPerPage = this.$route.query.size ? Number(this.$route.query.size) : 10;
      this.options.sortBy = [];
      this.options.sortDesc = [];
      if (this.$route.query.sort) {
        const sortList = this.$route.query.sort.split(',');
        for (let i = 0; i < sortList.length; i += 1) {
          this.options.sortBy.push(sortList[i].split(' ')[0]);
          if (sortList[i].split(' ')[1] === 'asc') {
            this.options.sortDesc.push(false);
          } else {
            this.options.sortDesc.push(true);
          }
        }
      }
      if (this.searchAttributes) {
        for (let i = 0; i < this.searchAttributes.length; i += 1) {
          const attr = this.searchAttributes[i];
          if (this.$route.query[attr]) {
            this.$set(this.search, attr, this.$route.query[attr]);
          }
        }
      }
    }
    this.getDataFromApi().then(data => {
      this.items = data.items;
      this.totalItems = data.total;
      this.firstLoad = false;
    });
    this.item.email = localStorage.getItem('email') || '';
  },
  computed: {
    role() {
      return this.$store.getters.roles;
    },
  },
  methods: {
    triggerSearch() {
      console.log('[Table] Search watch');
      if (!this.firstLoad) {
        this.options.page = 1;
        this.changeOptions();
      }
    },
    changeOptions() {
      this.$router.push({
        path: this.$router.path,
        query: this.getParams(),
      });
      let currentPathName = this.$router.currentRoute.name;
      localStorage[currentPathName] = this.$router.currentRoute.fullPath;
    },
    getDataFromApi() {
      console.log('[Table] Loading data');
      this.loading = true;
      EventBus.$emit('waiting', true);
      return new Promise(resolve => {
        this.axios
          .get(`${this.urlApi}?`, {
            params: this.getParams(),
          })
          .then(res => {
            let items = [];
            let total = 0;
            if (res.status === 200) {
              items = res.data.content;
              total = res.data.total;
            }
            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total,
              });
            });
          })
          .finally(() => {
            EventBus.$emit('waiting', false);
          });
      });
    },
    getParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const query = {
        index: page - 1,
        size: itemsPerPage,
      };
      let sort = '';
      for (let i = 0; i < sortBy.length; i += 1) {
        if (i !== 0) {
          sort += ',';
        }
        let dir = 'asc';
        if (sortDesc[i]) {
          dir = 'desc';
        }
        sort += `${sortBy[i]} ${dir}`;
      }
      if (sort !== '') {
        query.sort = sort;
      }
      if (this.searchAttributes) {
        for (let i = 0; i < this.searchAttributes.length; i += 1) {
          const attr = this.searchAttributes[i];
          if (this.search[attr]) {
            query[attr] = this.search[attr];
          }
        }
      }
      return query;
    },
    onViewItem(value) {
      console.log('Click View ' + value.id);
      this.dialogView = true;
      this.viewItem = value;
    },
    timestampDialog() {
      this.timestampView = true;
    },
    onDeleteItem() {
      this.disableDelete = true;
      let value = this.itemToBeDeleted;
      console.log('Click Delete ' + value.id);
      EventBus.$emit('waiting', true);
      this.axios
        .delete((this.urlApiDelete ? this.urlApiDelete : this.urlApi) + '/' + value.id)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('delete.success'),
          });
          this.deleteDialog = false;
          this.$emit('delete', value);
          this.disableDelete = false;
        })
        .catch(error => {
          console.log(error);
          this.disableDelete = false;
        })
        .finally(EventBus.$emit('waiting', false));
    },
    acceptOrder(item) {
      this.selectedOrder = { ...item };
      this.acceptOrderDialog = true;
    },
    rejectOrder(item) {
      this.selectedOrder = { ...item };
      this.rejectOrderDialog = true;
    },
    forceCompleteOffer(item) {
      this.selectedOrder = { ...item };
      this.forceCompleteDialog = true;
    },
    acceptOrderByProvider() {
      const uuid = this.selectedOrder.uuidProvider;
      const payload = {
        uuid: uuid,
        email: this.item.email,
        publicContactEmail: localStorage.getItem('email') || '',
        cost: this.item.cost,
        instructions: this.item.instructions,
        phone: this.item.phone,
        comments: this.item.comments,
      };

      this.axios
        .put(`/api/v1/orders-patent/accept-by-provider`, payload)
        .then(response => {
          console.log('Order accepted successfully:', response.data);
          this.acceptOrderDialog = false;
          EventBus.$emit('snackbar', {
            text: 'Order accepted successfully',
          });
          this.getDataFromApi().then(data => {
            this.items = data.items;
            this.totalItems = data.total;
            this.firstLoad = false;
          });
        })
        .catch(error => {
          console.error('Failed to accept order:', error);
        });
    },
    forceCompleteOfferByAdmin(item) {
      const uuid = item.uuidProvider;
      const payload = {
        uuid: uuid,
        commends: this.item.forceCompleteComments,
      };
      this.loading = true;
      this.axios
        .put('/api/v1/orders-patent/force-completed-by-provider', payload)
        .then(() => {
          console.log('Success');
          this.forceCompleteDialog = false;
          EventBus.$emit('snackbar', {
            text: 'Offer successfully completed',
          });
          this.item.forceCompleteComments = '';
          this.$refs.forceCompleteOrderForm.resetValidation();
          this.getDataFromApi().then(data => {
            this.items = data.items;
            this.totalItems = data.total;
            this.firstLoad = false;
          });
        })
        .catch(error => {
          console.log(error);
        })
        .finally((this.loading = false));
    },
    rejectOrderByProvider() {
      const uuid = this.selectedOrder.uuidProvider;
      const payload = {
        uuid: uuid,
        rejectComments: this.item.rejectComments || null,
        rejectionProviderReason: this.item.rejectionReason,
        publicContactEmail: localStorage.getItem('email') || '',
      };

      this.axios
        .put(`/api/v1/orders-patent/reject-by-provider`, payload)
        .then(response => {
          console.log('Order rejected successfully:', response.data);
          this.rejectOrderDialog = false;
          EventBus.$emit('snackbar', {
            text: 'Order rejected successfully',
          });
          this.item.rejectComments = '';
          this.item.rejectionReason = null;
          this.getDataFromApi().then(data => {
            this.items = data.items;
            this.totalItems = data.total;
            this.firstLoad = false;
          });
        })
        .catch(error => {
          console.error('Failed to reject order:', error);
        });
    },
  },
};
</script>

<style>
.v-application--is-ltr .v-data-table__mobile-row__cell {
  text-align: left;
}

tr {
  min-height: 200px;
  height: 100%;
}

#table-orders
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:first-child {
  width: 97px !important;
}

.custom-rating {
  color: #e9ae1ae0;
}
</style>
